import { PerspectiveCamera } from '@react-three/drei';

function CameraIntro() {
  return (
    <PerspectiveCamera
      makeDefault
      zoom={3.5}
      near={1}
      far={2000}
      position={[-100, -90, 100]}
      fov={40}
    />
  );
}

export default CameraIntro;
